WiseMetering.Views.Ui.Widget.ValueDisplayer = WiseMetering.Views.Ui.Widget.Base.extend({
    templateID: 'templates/ui/widgets/value_displayer',
    chartDisplayer: false,

    initialize: function(params) {
        WiseMetering.Views.Ui.Widget.Base.prototype.initialize.call(this, params);
    }
});
